<template>
  <div class="fnss-card">
    <div v-if="title || $slots.title" class="fnss-card-header vux-1px-b">
      <div class="fnss-card-header-title">
        <template v-if="$slots.title">
          <slot name="title"></slot>
        </template>
        <template v-else>
          {{ title }}
        </template>
      </div>
      <div class="fnss-card-header-extra">
        <slot name="extra"></slot>
      </div>
    </div>
    <div class="fnss-card-body" :style="{ padding: bodyPadding }">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    bodyPadding: {
      type: String,
      default: "0px"
    }
  }
};
</script>
<style lang="less">
.fnss-card {
  background-color: #ffffff;
  &-header {
    padding: 0 15px;
    font-size: 15px;
    line-height: 35px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(119, 119, 119, 1);
    display: flex;
    justify-content: space-between;
  }
  &-item {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 400;
    &-horizontal {
      padding: 10px 15px;
      font-family: PingFangSC-Regular;
    }
    &-vertical-item {
      flex: 1;
      display: flex;
      flex-flow: column;
      align-items: center;
      &:last-child:after {
        border: none;
      }
    }
    &-left {
      color: rgba(71, 71, 71, 1);
    }
    &-right {
      color: rgba(145, 145, 145, 1);
    }
    &:last-child:after {
      border: none;
    }
  }
}
</style>
